module.exports = __webpack_public_path__ + "static/media/search-white.5432170c.svg";